<template>
  <v-form ref="form">
    <question-answer-card v-for="(question, index) in questions" :key="question.id" :question="question"
      :index="index" :references="referencesFor(question)"
      :editable-label="$t('views.appraisals.show.finalAnswer')" :value="localAnswers[question.id]"
      @input="setAnswer(question, $event)" :error="errors[question.id]" :answer-label="answerLabel"
      :question-types="questionTypes" :required-rule="requiredRule" />
  </v-form>
</template>

<script>
import answerValidationMixin from './answerValidationMixin';
import {formatAnswer} from '../../helpers/appraisalAnswers';
import QuestionAnswerCard from './QuestionAnswerCard';

export default {
  name: 'FinalAnswer',
  components: {QuestionAnswerCard},
  mixins: [answerValidationMixin],
  props: {
    employeeAnswers: {
      type: Object,
      required: true
    },
    supervisorAnswers: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localAnswers: this.buildDefaultAnswers(this.value)
    };
  },
  watch: {
    localAnswers: {
      deep: true,
      handler(answers) {
        this.$emit('input', answers);
        this.refreshErrors();
      }
    }
  },
  methods: {
    formatAnswer,
    referencesFor(question) {
      return [
        {
          label: this.$t('views.appraisals.show.employeeResponse'),
          value: this.formatAnswer(question, this.employeeAnswers[question.id])
        },
        {
          label: this.$t('views.appraisals.show.managerAnswers'),
          value: this.formatAnswer(question, this.supervisorAnswers[question.id])
        }
      ];
    },
    setAnswer(question, answer) {
      this.$set(this.localAnswers, question.id, answer);
    },
    refreshErrors() {
      if (!this.hasAttemptedValidation) {
        return;
      }
      this.questions.forEach((question) => {
        this.$set(this.errors, question.id, this.isQuestionAnswered(question) ? '' : this.answerRequiredMessage);
      });
    }
  }
};
</script>
